import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M15.003 7.778s1.796 2.907 2.017 4.347 1.962 2.507 1.437 3.493c-.525.987-1.658.774-1.768 1.387s1.658 3.44-.25 3.893c-1.906.454-5.886-.72-6.383-1.386"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M4.483 21c.159-.285 1.957-2.385.767-4.536C4.06 14.312.964 9.517 3.425 6.769s8.28-3.266 10.58-2.359c2.302.907 2.302 2.981-.078 3.266s-2.884.44-2.963.96c-.106.518.82 2.67-.212 2.98-1.005.286-4.259.623-4.312 1.53s1.693 2.98 2.646 1.322c.952-1.66-1.818-3.673-3.829-3.155"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="m19.315 3.55.232-.727a1.36 1.36 0 1 1 2.176 1.453l-2.169 1.838a1.175 1.175 0 0 0 .3 1.977l.209.09a1.315 1.315 0 0 0 1.768-.81l.147-.459"
    />
    <circle
      cx={20.257}
      cy={10.757}
      r={1}
      fill="currentColor"
      transform="rotate(17.738 20.257 10.757)"
    />
  </svg>
);
export const HeadConfusedIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
